import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './Modal.scss';

import { BodyRenderer } from '../index.js';

class Modal extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    title: PropTypes.string.isRequired,
    onHide: PropTypes.func,
  };

  static defaultProps = {
    className: '',
    onHide: () => {},
  };

  constructor(props) {
    super(props);
    this.handleEscape = this.handleEscape.bind(this);
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleEscape);
    document.body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleEscape);
    document.body.style.overflow = 'auto';
  }

  handleEscape(event) {
    const key = event.which || event.keyCode || event.charCode;
    if (key === 27) {
      // esc key
      this.props.onHide();
    }
  }

  handleHide(e) {
    if (e.target === this.modal) {
      this.props.onHide();
    }
  }

  render() {
    return (
      <BodyRenderer>
        <div className="common-modal-container">
          <div className="common-modal-shade" />
          <div
            className="common-modal"
            ref={ref => (this.modal = ref)}
            onClick={e => this.handleHide(e)}
          >
            <div
              className={classnames(
                'common-modal__content',
                this.props.className
              )}
            >
              <div className="common-modal__header">
                <div className="common-modal__title">{this.props.title}</div>
                <div
                  className="common-modal__close-button"
                  onClick={this.props.onHide}
                >
                  <i className="fa fa-times" />
                </div>
              </div>
              <div className="common-modal__body">{this.props.children}</div>
            </div>
          </div>
        </div>
      </BodyRenderer>
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/common/modal/Modal.js